import React from "react";
import { FormGroup, FormLabel } from "react-bootstrap";
import { Answers } from "./Answers";
import { InputBox } from "..";
import { QuestionInterface, AnswerInterface, ArrayHelper, PendingCommand } from "../../helpers";

interface Props {
  question: QuestionInterface,
  answer: AnswerInterface,
  allQuestions: QuestionInterface[],
  updateValue: (questionId: number, newValue: string) => void,
  sendCommand: (cmd: PendingCommand) => void
}

interface ChildItem {
  answers: AnswerInterface[]
}

export const AnswerArray: React.FC<Props> = props => {

  const [childItems, setChildItems] = React.useState<ChildItem[]>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<number>(null);

  const sendCommand = (cmd: PendingCommand) => {
    if (cmd.action === "editImage") {
      //cmd.action = "editArrayImage"
      cmd.parameter.parentAnswer = props.answer;
      cmd.parameter.parentQuestion = props.question;
    }
    props.sendCommand(cmd);
  }

  const updateChildAnswers = () => {
    if (props.question && props.answer) {
      const val = props.answer.value;
      if (val.indexOf("[") === 0) {
        populateChildAnswers(JSON.parse(val));
      } else if (val.indexOf("http") === 0) {
        fetch(val, { method: "GET" }).then(response => response.json()).then(data => populateChildAnswers(data));
      } else {
        setChildItems([]);
      }
    }
  }

  const populateChildAnswers = async (data: any[]) => {
    const result: ChildItem[] = [];
    data.forEach(d => {
      const item: ChildItem = { answers: [] }
      Object.getOwnPropertyNames(d).forEach((name: string) => {
        const q = ArrayHelper.getOne(props.question.children, "keyName", name);
        item.answers.push({ questionId: q.id, value: d[name] });
      });
      result.push(item);
    });
    setChildItems(result);
  }

  const addItem = () => {
    const result = [...childItems];
    const newItem: ChildItem = { answers: [] };
    props.question.children.forEach(q => {
      newItem.answers.push({ questionId: q.id, value: "" })
    });
    result.push(newItem);
    setChildItems(result);
    setSelectedIndex(result.length - 1);
  }

  const getAnswerRows = () => {
    const result: JSX.Element[] = [];
    if (childItems) {
      let i = 0;
      childItems.forEach(item => {
        const idx = i;
        const label = (item.answers.length > 0) ? item.answers[0].value || "Item" : "Item";
        result.push(<tr><td><a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedIndex(idx) }}>{label}</a></td></tr>)
        i++;
      });
    }
    return result;
  }


  const handleValueUpdate = (questionId: number, newValue: string) => {
    const result = [...childItems];
    const item = ArrayHelper.getOne(result[selectedIndex].answers, "questionId", questionId);
    item.value = newValue;
    setChildItems(result);
  }

  const removeItem = () => {
    const result = [...childItems];
    result.splice(selectedIndex, 1);
    setChildItems(result);
    setSelectedIndex(null);
  }

  const getEditContent = () => {
    if (selectedIndex !== null) {
      return (
        <div style={{ paddingLeft: 10, paddingRight: 10 }}>
          <InputBox headerIcon="far fa-image" headerText="Edit Item" saveText="Update" saveFunction={() => { setSelectedIndex(null) }} deleteFunction={removeItem} >
            <Answers questions={props.question.children} answers={childItems[selectedIndex].answers} updateValue={handleValueUpdate} sendCommand={sendCommand} />
          </InputBox>
        </div>
      )
    }
  }

  const updateJson = () => {
    const result: any[] = []
    childItems?.forEach(ci => {
      const item: any = {};
      props.question?.children?.forEach(q => {
        const a: AnswerInterface = ArrayHelper.getOne(ci.answers, "questionId", q.id);
        item[q.keyName] = a?.value?.trim() || "";
      });
      result.push(item);
    });
    props.updateValue(props.question.id, JSON.stringify(result));

  }

  React.useEffect(updateChildAnswers, [props.question, props.answer]); // eslint-disable-line
  React.useEffect(updateJson, [childItems]); // eslint-disable-line

  return (
    <FormGroup>
      <a href="about:blank" className="float-right text-success" onClick={(e) => { e.preventDefault(); addItem() }} ><i className="fas fa-plus"></i> New</a>
      <FormLabel>{props.question.title}</FormLabel>
      <table className="table tabmle-sm">
        {getAnswerRows()}
      </table>
      {getEditContent()}
    </FormGroup>
  )


}